import { render, staticRenderFns } from "./ResidentialApartment.vue?vue&type=template&id=019dce82&scoped=true&"
import script from "./ResidentialApartment.vue?vue&type=script&lang=ts&"
export * from "./ResidentialApartment.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentialApartment.vue?vue&type=style&index=0&id=019dce82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019dce82",
  null
  
)

export default component.exports